import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ConfigurationProductFamilyCategoriesDataGrid } from "src/components/views/erp/configurator/managing/productFamilyCategories/ConfigurationProductFamilyCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/configurator/productFamilyCategories")({
	staticData: {
		title: i18n.t("product_family_categories"),
		legacyViewKey: "configurationProductFamilyCategoriesView",
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <ConfigurationProductFamilyCategoriesDataGrid />;
}
